import { DataField, SelectOption } from '@sageworks/jpi';
import { TemplateDataField } from '../../../../../enums';
import { DataFieldConvertStrategy } from '../../data-field-convert-strategy';
import { DropdownDataFieldConverter } from '../dropdown/dropdown-data-field-converter';

export class BusinessInvestmentsDataFieldConverter implements DataFieldConvertStrategy {
	private readonly allowedFields = new Set<number>([TemplateDataField.BusinessSubEntityType]);
	private readonly subEntityTypeDropdownOptions: SelectOption[] = [
		{
			label: 'Traditional',
			value: 0 as Object
		} as SelectOption,
		{
			label: 'Real Estate',
			value: 7 as Object
		} as SelectOption
	];

	private readonly dropdownDataFieldConverter = new DropdownDataFieldConverter();

	isFieldValid(dataField: DataField): boolean {
		return this.allowedFields.has(dataField.templateDataFieldId!);
	}

	convert(dataField: DataField, currentProperties: any) {
		const properties = { ...currentProperties };
		const convertedDataFieldProperties = this.dropdownDataFieldConverter.convert(dataField, properties);

		convertedDataFieldProperties.data.values = this.subEntityTypeDropdownOptions;
		convertedDataFieldProperties.dataSrc = 'values';

		return convertedDataFieldProperties;
	}
}
